"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.search");
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _global = _interopRequireDefault(require("../../utils/global"));
var _auth = require("@/utils/auth");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _marketing = require("@/api/marketing");
var _requestOver = _interopRequireDefault(require("./dialogs/requestOver.vue"));
var _order = require("@/api/order");
var _mayi = require("@/api/mayi");
var _merchant = require("@/api/merchant");
var _emergencyContact = _interopRequireDefault(require("./dialogs/emergencyContact"));
var _checklease = _interopRequireDefault(require("./dialogs/checklease"));
var _viewAgreement = _interopRequireDefault(require("./dialogs/viewAgreement"));
var _maYiPayRule = _interopRequireDefault(require("./dialogs/maYiPayRule"));
var _orderShareList = _interopRequireDefault(require("./dialogs/orderShareList"));
var _checklRiskArea = _interopRequireDefault(require("./dialogs/checklRiskArea"));
var _setAddress = _interopRequireDefault(require("./dialogs/setAddress"));
var _setUserInfo = _interopRequireDefault(require("./dialogs/setUserInfo"));
var _cancelOrderEquity = _interopRequireDefault(require("./dialogs/cancelOrderEquity.vue"));
var _queryOrderEquity = _interopRequireDefault(require("./dialogs/queryOrderEquity.vue"));
var _showAreaDetail = _interopRequireDefault(require("./dialogs/showAreaDetail"));
var _setDistributionOrder = _interopRequireDefault(require("./dialogs/setDistributionOrder"));
var _setAuditOrder = _interopRequireDefault(require("./dialogs/setAuditOrder"));
var _refushDistributionOrder = _interopRequireDefault(require("./dialogs/refushDistributionOrder"));
var _setDevice = _interopRequireDefault(require("./dialogs/setDevice"));
var _setSetmeal = _interopRequireDefault(require("./dialogs/setSetmeal"));
var _setService = _interopRequireDefault(require("./dialogs/setService"));
var _setRelet = _interopRequireDefault(require("./dialogs/setRelet"));
var _setRemark = _interopRequireDefault(require("./dialogs/setRemark"));
var _checkRemark = _interopRequireDefault(require("./dialogs/checkRemark"));
var _checkFlow = _interopRequireDefault(require("./dialogs/checkFlow"));
var _delivery = _interopRequireDefault(require("./dialogs/delivery"));
var _receipt = _interopRequireDefault(require("./dialogs/receipt"));
var _authInfo = _interopRequireDefault(require("./dialogs/authInfo"));
var _checkBill = _interopRequireDefault(require("./dialogs/checkBill"));
var _checkLogistics = _interopRequireDefault(require("./dialogs/checkLogistics"));
var _applyCloseOrder = _interopRequireDefault(require("./dialogs/applyCloseOrder"));
var _setRiskReject = _interopRequireDefault(require("./dialogs/setRiskReject"));
var _checkRisk = _interopRequireDefault(require("@/components/dialogs/checkRisk"));
var _checkRiskTwo = _interopRequireDefault(require("@/components/dialogs/checkRiskTwo"));
var _checkRiskThree = _interopRequireDefault(require("@/components/dialogs/checkRiskThree"));
var _checkRiskZhima = _interopRequireDefault(require("@/components/dialogs/checkRiskZhima"));
var _checkRiskJiaohu = _interopRequireDefault(require("@/components/dialogs/checkRiskJiaohu"));
var _checkRiskJiaohuZhangqian = _interopRequireDefault(require("@/components/dialogs/checkRiskJiaohuZhangqian"));
var _checkRiskConcern = _interopRequireDefault(require("@/components/dialogs/checkRiskConcern.vue"));
var _openZhangqian = _interopRequireDefault(require("./dialogs/openZhangqian"));
var _saveCostFun = _interopRequireDefault(require("./dialogs/saveCostFun"));
var _serviceInfo = _interopRequireDefault(require("./dialogs/serviceInfo"));
var _orderInfo = _interopRequireDefault(require("./dialogs/orderInfo"));
var _contractInfo = _interopRequireDefault(require("./dialogs/contractInfo"));
var _chooseContract = _interopRequireDefault(require("./dialogs/chooseContract"));
var _editOutBoundForm = _interopRequireDefault(require("@/views/inOutBound/dialog/editOutBoundForm.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//掌签
//浓度算法
//出库组件
var _default = {
  components: {
    myDatePicker: _myDatePicker.default,
    customPage: _customPage.default,
    checkLease: _checklease.default,
    viewLeaseAgree: _viewAgreement.default,
    emergencyContact: _emergencyContact.default,
    maYiPayRule: _maYiPayRule.default,
    orderShareList: _orderShareList.default,
    checklRiskArea: _checklRiskArea.default,
    setAddress: _setAddress.default,
    setUserInfo: _setUserInfo.default,
    showAreaDetail: _showAreaDetail.default,
    setDistributionOrder: _setDistributionOrder.default,
    setAuditOrder: _setAuditOrder.default,
    refushDistributionOrder: _refushDistributionOrder.default,
    setDevice: _setDevice.default,
    setSetmeal: _setSetmeal.default,
    setService: _setService.default,
    setRelet: _setRelet.default,
    setRemark: _setRemark.default,
    checkRemark: _checkRemark.default,
    checkFlow: _checkFlow.default,
    delivery: _delivery.default,
    receipt: _receipt.default,
    authInfo: _authInfo.default,
    checkBill: _checkBill.default,
    checkLogistics: _checkLogistics.default,
    applyCloseOrder: _applyCloseOrder.default,
    setRiskReject: _setRiskReject.default,
    checkRisk: _checkRisk.default,
    checkRiskTwo: _checkRiskTwo.default,
    checkRiskThree: _checkRiskThree.default,
    checkRiskZhima: _checkRiskZhima.default,
    checkRiskJiaohu: _checkRiskJiaohu.default,
    checkRiskJiaohuZhangqian: _checkRiskJiaohuZhangqian.default,
    openZhangqian: _openZhangqian.default,
    saveCostFun: _saveCostFun.default,
    serviceInfo: _serviceInfo.default,
    orderInfo: _orderInfo.default,
    contractInfo: _contractInfo.default,
    chooseContract: _chooseContract.default,
    requestOver: _requestOver.default,
    cancelOrderEquity: _cancelOrderEquity.default,
    queryOrderEquity: _queryOrderEquity.default,
    checkRiskConcern: _checkRiskConcern.default,
    editOutBound: _editOutBoundForm.default
  },
  data: function data() {
    return {
      loading: false,
      checkAll: false,
      isIndeterminate: false,
      checkList: [],
      merchantId: 0,
      orderStatus: 0,
      orderCreateTime: [],
      searchForm: {
        merchantId: '',
        merchantChildId: '',
        reciveStatus: '',
        orderNo: '',
        goodsName: '',
        receivingName: '',
        receivingMobile: '',
        riskName: '',
        riskMobile: '',
        orderStatus: '',
        orderCreateTime: '',
        leaseDate: '',
        shear: '',
        shearMobile: '',
        p_user_id: '',
        is_lock_phone: '',
        is_renewal: '',
        is_pay: '',
        order_type: 0
      },
      zhanQianInfo: {},
      statusList: _global.default.orderStatus,
      merchantList: [{
        id: 0,
        username: '请选择'
      }],
      merchantListForTrans: [{
        id: 0,
        username: '请选择'
      }],
      isLockList: [{
        id: -1,
        name: '请选择'
      }, {
        id: 0,
        name: '无锁'
      }, {
        id: 1,
        name: '有锁'
      }],
      orderTypeList: [{
        id: 0,
        name: '请选择'
      }, {
        id: 1,
        name: '芝麻代扣'
      }, {
        id: 2,
        name: '蚂蚁代扣'
      }, {
        id: 3,
        name: '平台免押'
      }, {
        id: 5,
        name: '签约代扣'
      }],
      merchantChildList: [{
        id: 0,
        username: '未分配'
      }],
      reciveStatusList: [{
        id: 3,
        label: '未分配'
      }, {
        id: 0,
        label: '未接单'
      }, {
        id: 1,
        label: '已接单'
      }, {
        id: 2,
        label: '已拒绝'
      }],
      total: 0,
      tableData: [],
      activeName: 'all',
      tabList: [{
        id: 'all',
        name: '全部订单',
        count: 0
      }, {
        id: 'notPay',
        name: '待付款订单',
        count: 0
      }, {
        id: 'notRisk',
        name: '待审核订单',
        count: 0
      }, {
        id: 'deliveredNot',
        name: '待发货订单',
        count: 0
      }, {
        id: 'deliveredIs',
        name: '已发货订单',
        count: 0
      }, {
        id: 'orderIng',
        name: '租用中订单',
        count: 0
      }, {
        id: 'orderCompleted',
        name: '交易完成订单',
        count: 0
      }, {
        id: 'orderCancel',
        name: '取消订单',
        count: 0
      }, {
        id: 'orderReturn',
        name: '归还订单',
        count: 0
      }, {
        id: 'orderBuyout',
        name: '买断订单',
        count: 0
      }, {
        id: 'orderRenewal',
        name: '续租订单',
        count: 0
      }, {
        id: 'orderRefund',
        name: '退款订单',
        count: 0
      }],
      selectedId: '',
      orderNo: '',
      editItem: {},
      channelList: [],
      channelShare: [{
        key: 0,
        name: '全部'
      }, {
        key: 1,
        name: '是'
      }, {
        key: 2,
        name: '否'
      }],
      selectList: [],
      selectListMer: [],
      returnVisible: false,
      refuseId: '',
      returnForm: {
        checkRefuseReason: ''
      },
      selectedContractState: {},
      //合同选择状态
      selectedItem: {}
    };
  },
  watch: {
    orderCreateTime: function orderCreateTime(val) {
      if (val) {
        this.searchForm.orderCreateTime = val.join('~');
      } else {
        this.searchForm.orderCreateTime = '';
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.params.orderId) {
      this.searchForm.orderNo = this.$route.params.orderId;
    }
    if (this.$route.params.pUserId) {
      this.searchForm.p_user_id = this.$route.params.pUserId;
    }
    if (this.$route.query.orderId) {
      this.searchForm.orderNo = this.$route.query.orderId;
    }
    var merchantId = (0, _auth.getMerchantId)();
    // 判断是否商户
    if (merchantId) {
      this.merchantId = merchantId;
      this.searchForm.merchantId = merchantId;
      this.getMerchantChildList();
    }
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.initCreateTime();
      this.getDistributionMerchantList();
      this.getDistributionMerchantListForTrans();
      this.getSelect();
      this.getChannelList();
      this.$nextTick(function () {
        _this.getList();
      });
    },
    initCreateTime: function initCreateTime() {
      this.orderCreateTime = [this.$func.dateFormat('yyyy-mm-01 00:00:00', new Date(this.$func.dateFormat('yyyy'), this.$func.dateFormat('mm') - 3)), this.$func.dateFormat('yyyy-mm-dd 23:59:59')];
    },
    showAreaDetail: function showAreaDetail(item) {
      var province = [item.prov, item.city];
      if (item.area) {
        province.push(item.area);
      }
      this.editItem = {
        address: item.address,
        prov: item.prov,
        city: item.city,
        area: item.area,
        province: province
      };
      this.$refs.showAreaDetail.dialogVisible = true;
    },
    // 获取数据
    getList: function getList(flag) {
      // flag为true, 则不刷新表格
      this.getOrderList(flag);
      this.getListCount();
    },
    getOrderList: function getOrderList(flag) {
      var _this2 = this;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      this.loading = true;
      if (!flag) {
        this.tableData = [];
      }
      (0, _order.orderList)((0, _objectSpread2.default)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize,
        allList: this.$hasMethod('#allList')
      }, this.searchForm), {}, {
        orderStatusGroup: this.activeName
      })).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.loading = false;
      });
    },
    getListCount: function getListCount() {
      var _this3 = this;
      (0, _order.orderListCount)((0, _objectSpread2.default)((0, _objectSpread2.default)({
        allList: this.$hasMethod('#allList')
      }, this.searchForm), {}, {
        orderStatusGroup: this.activeName
      })).then(function (res) {
        var _iterator = (0, _createForOfIteratorHelper2.default)(_this3.tabList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.count = res[item.id];
            if (_this3.activeName == item.id) {
              _this3.total = res[item.id] || 0;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    openTip: function openTip() {
      this.$alert('商家暂未开启风控', '提示', {
        confirmButtonText: '确定'
      }).then(function () {});
    },
    handleRefundOrder: function handleRefundOrder(tradeNo) {
      var routeData = this.$router.resolve({
        name: 'refundList',
        query: {
          tradeNo: tradeNo
        }
      });
      // console.log('handleRefundOrder', routeData.href)
      this.$func.openWindow(routeData.href);
    },
    jumpListByMobile: function jumpListByMobile(mobile, times) {
      console.log(mobile, times);
      if (times > 1) {
        this.searchForm.riskMobile = mobile;
        var merchantId = (0, _auth.getMerchantId)();
        // 判断是否商户
        if (merchantId) {
          this.merchantId = merchantId;
          this.searchForm.merchantId = merchantId;
        } else {
          this.getDistributionMerchantList();
        }
        this.getSelect();
        this.getList();
      }
    },
    jumpListByRiskName: function jumpListByRiskName(cert_name) {
      this.searchForm.riskName = cert_name;
      this.getList();
    },
    // 查看合同
    checkPact: function checkPact(url) {
      window.open(url);
    },
    refresh: function refresh() {
      this.getList(true);
    },
    // 订单完结
    // 这个方法只要负责跳转到完成申请表即可，不做其他处理
    finishOrder: function finishOrder(id, item) {
      console.log('trno', item.trade_no);
      // return;
      this.$router.push({
        path: '/auditOrder/auditOrderFinish?orderId=' + item.trade_no
      });

      // return
      // this.$confirm('交易完成后进行解约现有款项不退款，并解约代扣无法发起未代扣的期数！', '请确认是否交易完成？', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      // })
      //     .then(() => {
      //         orderFinish(id).then((res) => {
      //             this.getList(true)
      //         })
      //     })
      //     .catch(() => {})
    },
    // 商户申请完结
    finishOrderMerchant: function finishOrderMerchant(id) {
      this.selectedItem = {
        order_id: id
      };
      console.log('selectedItem', this.selectedItem);
      this.$refs.requestOver.dialogVisible = true;
      // return
      // this.$confirm('交易完成后进行解约现有款项不退款，并解约代扣无法发起未代扣的期数！', '请确认是否申请完成交易？', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      // })
      //     .then(() => {
      //         orderCloseMerchant({
      //             order_id: id,
      //             apply_type: 1,
      //         }).then((res) => {
      //             this.getList(true)
      //         })
      //     })
      //     .catch(() => {})
    },
    cancelwithhold: function cancelwithhold(id) {
      var _this4 = this;
      this.$confirm('取消代扣后，该笔订单自动扣款将停止，只能用户主动支付或者后台发起代扣', '是否确认取消？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.cancelWithholdForId)({
          order_id: id
        }).then(function (res) {
          _this4.getList(true);
        });
      }).catch(function () {});
    },
    doButout: function doButout(id) {
      var _this5 = this;
      this.$confirm('执行买断守约仅用于用户已买断，且支付宝订单显示待守约', '是否确认取消？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderDoButout)({
          order_id: id
        }).then(function (res) {
          _this5.getList(true);
        });
      }).catch(function () {});
    },
    mayiOrderRecis: function mayiOrderRecis(id) {
      var _this6 = this;
      this.$confirm('仅用于买订单拒绝用户发起取消代扣申请', '是否确认取消？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.mayiOrderRecission)({
          order_id: id
        }).then(function (res) {
          _this6.getList(true);
        });
      }).catch(function () {});
    },
    passRefund: function passRefund(item) {
      var _this7 = this;
      this.$confirm('同意退款，允许供应商退款，并放弃该订单！', '请确认是同意退款？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderCloseMerchant)({
          order_id: item.id,
          apply_type: 2
        }).then(function (res) {
          _this7.getList(true);
        });
      }).catch(function () {});
    },
    // 同意归还
    agreeReturn: function agreeReturn(id) {
      var _this8 = this;
      this.$confirm('确定要同意归还吗？', '同意归还', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderReturnAgree)(id).then(function (res) {
          _this8.getList(true);
        });
      }).catch(function () {});
    },
    // 同意归还订单长期未发货变更回租用中
    orderGoRent: function orderGoRent(id) {
      var _this9 = this;
      this.$confirm('确定要变回租用中码？需要确认用户未归还物品？', '是否确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderGoRent)(id).then(function (res) {
          _this9.getList(true);
        });
      }).catch(function () {});
    },
    // 拒绝归还
    refuseReturn: function refuseReturn(id) {
      this.refuseId = id;
      this.returnVisible = true;
    },
    // 订单关闭
    closeOrder: function closeOrder(id, status) {
      var _this10 = this;
      var title = '确定要关闭订单吗?';
      if (status == 10) {
        title = '订单可能有金额交易，关闭后涉及订单的金额和物品不做处理，需要客服独立处理，请确认?';
      }
      this.$confirm(title, '关闭', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderClose)(id).then(function (res) {
          _this10.getList(true);
        });
      }).catch(function () {});
    },
    successOrderReturn: function successOrderReturn(id) {
      var _this11 = this;
      this.$confirm('该操作不退款不退收益,仅变更订单状态,是否确认?', '变更状态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.successOrderReturn)({
          id: id
        }).then(function (res) {
          _this11.getList(true);
        });
      }).catch(function () {});
    },
    // 订单关闭
    closeOrderMerchant: function closeOrderMerchant(item) {
      this.editItem = item;
      this.$refs.applyCloseOrder.dialogVisible = true;
    },
    // 通过审核
    riskPass: function riskPass(item) {
      var _this12 = this;
      this.$confirm('确定要通过审核订单吗？', '订单审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        console.log(_this12.merchantId);
        if (_this12.merchantId) {
          (0, _order.saveDistributionOrder)({
            orderId: item.id,
            type: 1
          }).then(function (res) {
            (0, _order.riskPassApi)(item.id).then(function (res) {
              _this12.getList(true);
            }).catch(function () {});
          }).catch(function () {});
        }
      }).catch(function () {});
    },
    // 商户拒绝退款申请，继续订单流程
    merRefuseRefund: function merRefuseRefund(item) {
      var _this13 = this;
      this.$confirm('请先沟通用户，继续订单不退款？', '拒绝申请', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        if (_this13.merchantId) {
          (0, _order.merRefuseRefund)({
            orderId: item.id
          }).then(function (res) {
            _this13.getList(true);
          }).catch(function () {});
        }
      }).catch(function () {});
    },
    // 拒绝审核
    riskReject: function riskReject(item) {
      this.editItem = item;
      this.$refs.setRiskReject.dialogVisible = true;
    },
    openRiskArea: function openRiskArea(item, type) {
      this.editItem = item;
      this.editItem.type = type;
      this.$refs.checklRiskArea.dialogVisible = true;
    },
    // 订单上链
    mayiOrderCreate: function mayiOrderCreate(id) {
      var _this14 = this;
      this.$confirm('确定要上链订单信息吗？', '订单上链', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiChainCreate)(id).then(function (res) {
          _this14.$message.success('操作成功');
          _this14.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    //物流上链
    mayiOrderLogistic: function mayiOrderLogistic(id) {
      var _this15 = this;
      this.$confirm('确定要上链订单物流信息吗？', '物流上链', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiLogisticCreate)(id).then(function (res) {
          _this15.$message.success('操作成功');
          _this15.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    // 合约上链（承诺信息上链）
    mayiOrderPromise: function mayiOrderPromise(id) {
      var _this16 = this;
      this.$confirm('确定要上链租期信息吗？', '租期上链', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiLeasePromiseCreate)(id).then(function (res) {
          _this16.$message.success('操作成功');
          _this16.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    // 履约上链
    mayiOrderRental: function mayiOrderRental(id) {
      var _this17 = this;
      this.$confirm('确定要上传履约信息吗？', '履约信息（蚂蚁收钱）', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiLeaseRentalCreate)(id).then(function (res) {
          _this17.$message.success('操作成功');
          _this17.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    // 购买蚂蚁保险
    mayiOrderInsurance: function mayiOrderInsurance(id) {
      var _this18 = this;
      this.$confirm('确定要购买蚂蚁保险吗？', '蚂蚁保险', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiInsuranceCreate)(id).then(function (res) {
          _this18.$message.success('操作成功');
          _this18.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    // 退蚂蚁保险
    mayiOrderInsuranceCancel: function mayiOrderInsuranceCancel(id) {
      var _this19 = this;
      this.$confirm('确定要退蚂蚁保险吗？', '蚂蚁保险', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _mayi.maYiInsuranceCancel)(id).then(function (res) {
          _this19.$message.success('操作成功');
          _this19.getList(true);
        }).catch(function () {});
      }).catch(function () {});
    },
    closeReturn: function closeReturn() {
      this.returnVisible = false;
      this.returnForm.checkRefuseReason = '';
    },
    confirmReturnVisible: function confirmReturnVisible() {
      var _this20 = this;
      if (!this.returnForm.checkRefuseReason) {
        this.$message.warning('拒绝原因不能为空');
        return false;
      }
      (0, _order.orderReturnRefuse)({
        orderId: this.refuseId,
        checkRefuseReason: this.returnForm.checkRefuseReason
      }).then(function (res) {
        _this20.getList(true);
        _this20.closeReturn();
      }).catch(function () {});
    },
    // 确认归还
    confirmReturn: function confirmReturn(id) {
      var _this21 = this;
      this.$confirm('确定要归还吗？', '确认归还', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderComfirmReturn)(id).then(function (res) {
          _this21.getList(true);
        });
      }).catch(function () {});
    },
    // 标记订单是否设备锁订单
    saveLockStatus: function saveLockStatus(item) {
      var _this22 = this;
      var title = item.is_lock_phone == 0 ? '确认修改订单为可锁订单?' : '确认取消订单可锁状态?';
      var lock_status = (item.is_lock_phone + 1) % 2;
      this.$confirm(title, '确认修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.saveLockStatus)({
          id: item.id,
          lock_status: lock_status
        }).then(function (res) {
          _this22.getList();
        });
      }).catch(function () {});
    },
    // 归还完成
    // finishReturn(id){
    //   orderReturnFinish(id).then(res => {
    //     this.getList(true);
    //   });
    // },
    // 查看物流
    checkLogistics: function checkLogistics(item) {
      if (item.logistic.logistics_no || item.logistic.delivery_type == 2) {
        this.selectedId = item.id;
        this.$refs.checkLogistics.dialogVisible = true;
      } else {
        this.$message.warning('暂无物流信息');
      }
    },
    // 查看已付账单详情
    checkPaidBill: function checkPaidBill(id, paid_rent) {
      if (this.$hasMethod('#checkBill') && paid_rent > 0) {
        this.selectedId = id;
        this.$refs.checkBill.dialogVisible = true;
      }
    },
    // 查看认证资料
    checkAuthInfo: function checkAuthInfo(item) {
      // this.editItem = {
      //     idcard_back: item.idcard_back,
      //     idcard_front: item.idcard_front,
      // };
      this.editItem = item;
      this.$refs.authInfo.dialogVisible = true;
    },
    // 确认收货
    confirmReceipt: function confirmReceipt(id) {
      this.selectedId = id;
      this.$refs.receipt.dialogVisible = true;
    },
    // 订单发货
    openDelivery: function openDelivery(id) {
      this.selectedId = id;
      this.$refs.delivery.dialogVisible = true;
    },
    maYiCancelForSup: function maYiCancelForSup(id) {
      var _this23 = this;
      this.$confirm('主动退款仅用于蚂蚁订单，且只退蚂蚁代扣的钱，其余需要手动退款，请谨慎操作', '确认退款', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.maYiCancelForSup)({
          order_id: id
        }).then(function (res) {
          _this23.getList();
        });
      }).catch(function () {});
    },
    // 查看流水记录
    viewFlow: function viewFlow(trade_no) {
      this.selectedId = trade_no;
      this.$refs.checkFlow.dialogVisible = true;
    },
    // 查看合同
    viewContract: function viewContract(item) {
      // console.log('viewContract', item.esign_flow_id)
      if (item.esign_flow_id != '' && item.esign_sign_status == 2 || item.mayi_flow_id != '' && item.mayi_sign_status == 2) {
        this.editItem = item;
        this.$refs.contractInfo.dialogVisible = true;
      }
    },
    // 选择合同
    chooseContract: function chooseContract(item) {
      this.editItem = item;
      this.$refs.chooseContract.dialogVisible = true;
    },
    // 合同选择状态 - item包括order_id和status
    selectedState: function selectedState(item) {
      this.selectedContractState[item.order_id] = item.status;
    },
    // 查看客服备注
    viewRemark: function viewRemark(id) {
      this.selectedId = id;
      this.$refs.checkRemark.dialogVisible = true;
    },
    // 添加客服备注
    addRemark: function addRemark(id) {
      this.selectedId = id;
      this.$refs.setRemark.dialogVisible = true;
    },
    // 绑定续租商品
    setRelet: function setRelet(item) {
      this.editItem = item;
      this.$refs.setRelet.dialogVisible = true;
    },
    // 更改设备编号
    editDevice: function editDevice(item) {
      this.editItem = {
        orderId: item.id,
        deviceNumber: item.device_number ? item.device_number.split(',') : [],
        amount: item.amount
      };
      this.$refs.setDevice.dialogVisible = true;
    },
    // 增值服务
    addService: function addService(item) {
      this.editItem = (0, _objectSpread2.default)({}, item);
      this.$refs.setService.dialogVisible = true;
    },
    // 修改套餐
    editSetmeal: function editSetmeal(item) {
      this.editItem = (0, _objectSpread2.default)({}, item);
      this.$refs.setSetmeal.dialogVisible = true;
    },
    // 修改地址
    editAddress: function editAddress(item) {
      var province = [item.prov, item.city];
      if (item.area) {
        province.push(item.area);
      }
      this.editItem = {
        orderId: item.id,
        realname: item.realname,
        mobile: item.address_mobile,
        address: item.address,
        prov: item.prov,
        city: item.city,
        area: item.area,
        province: province
      };
      this.$refs.setAddress.dialogVisible = true;
    },
    // 修改用户邮箱以及身份证地址
    handleEditUserInfo: function handleEditUserInfo(item) {
      var id = item.id,
        email = item.email,
        real_addr = item.real_addr,
        goods_colour = item.goods_colour;
      this.editItem = {
        id: id,
        email: email,
        real_addr: real_addr,
        goods_colour: goods_colour
      };
      console.log('取出用户信息，修改email字段和身份证信息即可', this.editItem);
      this.$refs.setUserInfo.dialogVisible = true;
    },
    // 显示转单
    showDistributionOrder: function showDistributionOrder(item) {
      console.log('showDistributionOrder', item);
      this.editItem = {
        orderId: item.id,
        merchantId: item.merchant_id || ''
      };
      this.$refs.setDistributionOrder.dialogVisible = true;
    },
    refushDistributionOrder: function refushDistributionOrder(item) {
      ;
      this.selectedId = item.id, this.orderNo = item.trade_no;
      this.$refs.refushDistributionOrder.dialogVisible = true;
    },
    // 查看租期
    viewLease: function viewLease(item, status) {
      this.selectedId = item.id;
      this.orderStatus = status;
      this.editItem = item;
      this.$refs.checkLease.dialogVisible = true;
    },
    viewMaYiPayRule: function viewMaYiPayRule(item) {
      // this.selectedId = id
      // this.orderStatus = status
      this.editItem = item;
      this.$refs.maYiPayRule.dialogVisible = true;
    },
    viewLeaseAgree: function viewLeaseAgree(item) {
      this.selectedId = item.id;
      this.orderStatus = status;
      this.editItem = item;
      this.$refs.viewLeaseAgree.dialogVisible = true;
    },
    // 掌签征信开户
    openCredit: function openCredit(item) {
      var _this24 = this;
      this.$confirm('确认要征信开户吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var orderInfo = {
          order_id: item.id,
          name: item.cert_name,
          phone: item.mobile,
          ident_number: item.cert_no,
          amount: item.rent_total //总租金
        };
        // console.log('当前选中的orderInfo', orderInfo)
        _this24.loading = true;
        (0, _order.postOrderOverdue)(orderInfo).then(function (res) {
          // console.log('res', res)
          _this24.getList();
        });
      }).catch(function () {});
    },
    // 掌签征信上报催收
    reportToCreditBureau: function reportToCreditBureau(item, type) {
      var orderInfo = {
        order_id: item.id,
        name: item.cert_name,
        phone: item.mobile,
        ident_number: item.cert_no,
        amount: item.rent_total,
        //总租金
        is_report_credit: item.is_report_credit,
        // 是否开户
        is_add_compensatory: item.is_add_compensatory // 是否催收
      };

      this.zhanQianInfo = orderInfo;
      this.$refs.openZhangqian.dialogVisible = true; //传递参数信息，装备发起开户上报征信
    },
    checkRisk: function checkRisk(item, types) {
      console.log('item', item.is_report_credit, item.is_add_compensatory);
      this.selectedId = {
        order_id: item.id,
        name: item.cert_name,
        phone: item.mobile,
        ident_number: item.cert_no,
        type: types
      };
      switch (types) {
        case 1:
          this.$refs.checkRisk.dialogVisible = true;
          break;
        case 2:
          this.$refs.checkRiskTwo.dialogVisible = true;
          break;
        case 3:
          this.$refs.checkRiskThree.dialogVisible = true;
          break;
        case 4:
          this.$refs.checkRiskZhima.dialogVisible = true;
          break;
        case 5:
          this.$refs.checkRiskJiaohu.dialogVisible = true;
          break;
        case 6:
          this.confirmCheckRisk(6);
          break;
        case 7:
          this.confirmCheckRisk2(7, item);
          break;
      }
    },
    confirmCheckRisk: function confirmCheckRisk(type) {
      var _this25 = this;
      if (type == 6) {
        this.$confirm('确定查看报告吗？', '确认查看', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          _this25.$refs.checkRiskJiaohuZhangqian.dialogVisible = true; //掌签报告查看
        }).catch(function () {});
      }
    },
    confirmCheckRisk2: function confirmCheckRisk2(type, item) {
      var _this26 = this;
      if (type == 7) {
        this.$confirm('确定查看浓度报告吗？', '确认查看', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          _this26.selectedId = {
            order_id: item.id,
            seller_id: item.seller_id
          };
          _this26.$refs.checkRiskConcern.dialogVisible = true; //浓度报告查看
        }).catch(function () {});
      }
    },
    orderShareList: function orderShareList(item) {
      this.selectedId = item.id;
      this.orderNo = item.trade_no;
      this.$refs.orderShareList.dialogVisible = true;
    },
    getOrderStatusType: function getOrderStatusType(status) {
      var obj = this.statusList.find(function (item) {
        return item.id == status;
      });
      return obj ? obj.type : 'warning';
    },
    getOrderStatusName: function getOrderStatusName(status) {
      var obj = this.statusList.find(function (item) {
        return item.id == status;
      });
      return obj ? obj.name : '';
    },
    // 获取接单商户列表
    getDistributionMerchantList: function () {
      var _getDistributionMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getDistributionMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getDistributionMerchantList() {
        return _getDistributionMerchantList2.apply(this, arguments);
      }
      return getDistributionMerchantList;
    }(),
    // 获取接单商户列表
    getDistributionMerchantListForTrans: function () {
      var _getDistributionMerchantListForTrans = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _merchant.getDistributionMerchantList)({
                  status: 1,
                  trans_status: 1
                });
              case 2:
                res = _context2.sent;
                if (res.data) {
                  this.merchantListForTrans = res.data;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getDistributionMerchantListForTrans() {
        return _getDistributionMerchantListForTrans.apply(this, arguments);
      }
      return getDistributionMerchantListForTrans;
    }(),
    // 获取商户成员列表
    getMerchantChildList: function () {
      var _getMerchantChildList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res, _this$merchantChildLi;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _merchant.getMerchantChildList)();
              case 2:
                res = _context3.sent;
                console.log('getMerchantChildList', res);
                this.merchantChildList = this.$options.data().merchantChildList;
                if (res.data) {
                  (_this$merchantChildLi = this.merchantChildList).push.apply(_this$merchantChildLi, (0, _toConsumableArray2.default)(res.data));
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getMerchantChildList() {
        return _getMerchantChildList2.apply(this, arguments);
      }
      return getMerchantChildList;
    }(),
    // 获取商户名称
    getMerchantName: function getMerchantName(merchant_id) {
      var arr = this.merchantList.filter(function (item) {
        return item.id == merchant_id;
      });
      return arr.length ? arr[0].username : '';
    },
    // 获取商户成员名称
    getMerchantChildName: function getMerchantChildName(merchant_id) {
      var arr = this.merchantChildList.filter(function (item) {
        return item.id == merchant_id;
      });
      return arr.length ? arr[0].username : '';
    },
    // 查询
    search: function search() {
      var _this27 = this;
      this.$refs.customPage.page = 1;
      this.$nextTick(function () {
        _this27.getList();
      });
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      if (this.merchantId) {
        this.searchForm.merchantId = this.merchantId;
      }
      this.initCreateTime();
      this.search();
    },
    // 导出
    exportFile: function exportFile() {
      (0, _order.orderListExport)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), {}, {
        orderStatusGroup: this.activeName
      }));
    },
    // 导出租用中数据
    exportFileRent: function exportFileRent() {
      (0, _order.orderListRentExport)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), {}, {
        orderStatusGroup: this.activeName
      }));
    },
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
      this.$refs.customPage.page = 1;
      this.getList();
    },
    getChannelList: function getChannelList() {
      var _this28 = this;
      (0, _marketing.getChannelList)().then(function (res) {
        _this28.channelList = res.data || [];
      });
    },
    getSelect: function getSelect() {
      var _this29 = this;
      (0, _order.getOrderStatus)().then(function (res) {
        var list = [];
        for (var key in res) {
          list.push({
            id: key,
            name: res[key]
          });
        }
        _this29.selectList = list || [];
      });
      // getMerchant().then(res => {
      // 	this.selectListMer = res || [];
      // })
    },
    // 显示跟单分配
    showAuditOrder: function showAuditOrder(ids) {
      var merchant_child_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.getMerchantChildList();
      this.editItem = {
        orderId: ids,
        merchantChildId: merchant_child_id
      };
      this.$refs.setAuditOrder.dialogVisible = true;
    },
    // 电动车出库
    showAuditOrder2: function showAuditOrder2(ids) {
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      console.log('item', item);
      // this.getMerchantChildList()
      if (item.is_used != 0) {
        this.$router.push({
          path: '/inOutBound/out',
          query: {
            order_id: item.trade_no
          }
        });
        return;
      }
      this.getDistributionMerchantList();
      var month_total = item.month_total,
        trade_no = item.trade_no,
        user_id = item.uid,
        cert_name = item.cert_name,
        mobile = item.mobile,
        rent_price = item.rent_total; //订单ID必须，用于查找物流信息中的合同照片等
      this.editItem = {
        month_total: month_total,
        rent_price: rent_price,
        trade_no: trade_no,
        user_id: user_id,
        cert_name: cert_name,
        mobile: mobile,
        repair_record: '',
        widthImg: true
      };
      this.$refs.editOutBound.dialogVisible = true;
    },
    handleCheckAll: function handleCheckAll(val) {
      var checkList = [];
      if (val) {
        this.$refs.check.forEach(function (item) {
          checkList.push(item.label);
        });
      }
      this.checkList = checkList;
      this.isIndeterminate = false;
    },
    handleCheck: function handleCheck() {
      var len = this.checkList.length;
      if (len > 0 && len < this.$refs.check.length) {
        this.isIndeterminate = true;
      }
    },
    // 批量操作
    handleCommand: function handleCommand(command) {
      var ids = this.checkList;
      if (ids.length === 0) {
        this.$message({
          message: '没有勾选项',
          type: 'warning'
        });
        return;
      }
      switch (command) {
        case 'auditOrder':
          this.showAuditOrder(ids);
          break;
        default:
          break;
      }
    },
    ReletPass: function ReletPass(id) {
      var _this30 = this;
      // 申请续租通过
      this.$confirm('确定通过续租吗？', '确认续租', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderReletPass)({
          id: id
        }).then(function (res) {
          _this30.getList(true);
        });
      }).catch(function () {});
    },
    ReletReject: function ReletReject(id) {
      var _this31 = this;
      // 申请续租拒绝
      this.$confirm('确定拒绝续租申请，要求用户归还设备吗？', '确认拒绝', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _order.orderReletReject)({
          id: id
        }).then(function (res) {
          _this31.getList(true);
        });
      }).catch(function () {});
    },
    emergencyContact: function emergencyContact(item) {
      this.editItem = item;
      this.$refs.emergencyContact.dialogVisible = true;
    },
    showOrderInfo: function showOrderInfo(item) {
      var merchantInfo = {};
      this.merchantList.forEach(function (merchant) {
        if (item.merchant_id > 0 && merchant.id == item.merchant_id) {
          merchantInfo = (0, _objectSpread2.default)({}, merchant);
        }
      });
      console.log((0, _objectSpread2.default)({}, merchantInfo));
      this.editItem = item;
      this.editItem.merchantInfo = merchantInfo;
      this.$refs.orderInfo.dialogVisible = true;
    },
    /**
     * 公正操作，增加、取消、查询
     * type:0-增加，1-取消，2-查询
     * createOrderEquityAPI
        cancelOrderEquityAPI
        queryOrderEquityAPI
     **/
    confirmToEquity: function confirmToEquity(item, type, text) {
      var _this32 = this;
      console.log('item', item);
      // return;
      if (type == 0) {
        return this.$confirm('确定要创建公正信息吗？', '确认创建', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          // 创建公正操作
          (0, _order.createOrderEquityAPI)({
            order_id: item.id
          }).then(function (res) {
            _this32.getList(true);
          });
        }).catch(function () {});
      }
      if (type == 1) {
        this.editItem = {
          order_id: item.id,
          reason: ''
        };
        this.$refs.cancelOrderEquity.dialogVisible = true;
        return;
      }
      if (type == 2) {
        this.editItem = {
          order_id: item.id,
          cert_status: item.order_equity_status
        };
        this.$refs.queryOrderEquity.dialogVisible = true;
      }
    },
    saveCostFun: function saveCostFun(item) {
      this.editItem = item;
      this.$refs.saveCostFun.dialogVisible = true;
    },
    serviceInfo: function serviceInfo(item) {
      // 查看更多服务的支付金额和手续费
      this.editItem = item;
      this.$refs.serviceInfo.dialogVisible = true;
    },
    rzzltype: function rzzltype(risk_type_risky) {
      if (risk_type_risky > 0) {
        return '';
      } else {
        return 'border-btn';
      }
    }
  }
};
exports.default = _default;